import { render, staticRenderFns } from "./changeDutyDetail.vue?vue&type=template&id=472aeb1e&scoped=true"
import script from "./changeDutyDetail.vue?vue&type=script&lang=js"
export * from "./changeDutyDetail.vue?vue&type=script&lang=js"
import style0 from "./changeDutyDetail.vue?vue&type=style&index=0&id=472aeb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472aeb1e",
  null
  
)

export default component.exports